import styled from 'styled-components';

const HeroStyle = styled.section`
	--sizeImage: 32.05%;
	--distanceTitleTB: var(--sp6x);
	--breadcrumbDistance: var(--sp4x);

	.wrapper-hero {
		position: relative;
	}

	.wrapper-title {
		width: 100%;
		height: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		z-index: 1;
	}

	.wrapper-title-inner {
		margin-bottom: var(--distanceTitleTB);
	}

	.wrapper-hero {
		&::before {
			content: '';
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--backgroundColor);
			opacity: 0.25;
		}

		.wrapper-image {
			transform: scale(0);
		}

		.image-cont {
			--proportion: var(--sizeImage);
		}
	}

	.breadcrumb-wrapper {
		position: absolute;
		top: var(--breadcrumbDistance);
		left: var(--core_contPaddingLR);
		width: calc(100% - var(--core_contPaddingLR) * 2);
		overflow: hidden;

		div {
			padding: 0 !important;
			background-color: transparent !important;
		}

		.breadcrumb-inner-block {
			flex-wrap: nowrap !important;

			p:nth-of-type(n) {
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}

			p:first-of-type {
				white-space: nowrap !important;
				display: block;
				overflow: visible;
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeImage: 26.65%;
		--distanceTitleTB: var(--sp5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleTB: var(--sp4x);
		--breadcrumbDistance: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 27%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 28.82%;
		--distanceTitleTB: var(--sp5x);
		--breadcrumbDistance: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeImage: 58%;
		--distanceTitleTB: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceTitleTB: var(--sp3x);
		--sizeImage: 137.58%;

		.wrapper-title {
			padding: 0 var(--sp2x);
		}
	}
`;
export default HeroStyle;
